import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { Checkbox } from '@src/components';

interface CheckboxOption {
    label: string;
    value: string;
}

interface FormCheckboxGroupProps {
    label?: string;
    keyName: string;
    control: Control<any>;
    className?: string;
    formProps?: {
        options: CheckboxOption[];
        columns?: number;
    };
}

const columnClassMap: Record<number, string> = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
};

export const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({
    label,
    keyName,
    control,
    formProps,
    className,
}) => {
    const options = formProps?.options ?? [];

    const columnCount = formProps?.columns ?? 1;
    const columnClass = columnClassMap[columnCount] ?? 'grid-cols-1';

    return (
        <Controller
            control={control}
            name={keyName}
            defaultValue={[]}
            render={({ field: { value, onChange } }) => {
                const selectedValues: string[] = value ?? [];

                const toggleValue = (optionValue: string, checked: boolean) => {
                    if (checked) {
                        onChange([...selectedValues, optionValue]);
                    } else {
                        onChange(
                            selectedValues.filter((v) => v !== optionValue)
                        );
                    }
                };

                return (
                    <div className={className}>
                        {label && <p className="font-medium mb-2">{label}</p>}

                        <div className={`grid ${columnClass}  w-full`}>
                            {options.map((option) => {
                                const isChecked = selectedValues?.includes(
                                    option.value
                                );

                                return (
                                    <Checkbox
                                        key={option.value}
                                        checked={isChecked}
                                        onChange={(e) =>
                                            toggleValue(
                                                option.value,
                                                e.target.checked
                                            )
                                        }
                                        rootClassName={
                                            isChecked ? 'text-primary' : ''
                                        }
                                    >
                                        {option.label}
                                    </Checkbox>
                                );
                            })}
                        </div>
                    </div>
                );
            }}
        />
    );
};
